import { Component, OnDestroy, OnInit } from '@angular/core';
import { StreamService } from '../services';
import { takeUntil, tap, filter, flatMap, distinctUntilChanged } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Subject, BehaviorSubject } from 'rxjs';

@Component({
    template: `
        <div *ngIf="noTouching" fxLayoutAlign="center center" style="padding-top: 50px;"><spinner></spinner></div>
        <topic-summary-grid *ngIf="!noTouching" 
                            [topics]="topics" 
                            emptyMessage="Your team hasn't created topics yet."
                            (nextPage)="nextPage()">
        </topic-summary-grid>
    `
})
export class BrowseAllCatalogTopicsPaneComponent implements OnInit, OnDestroy {
    noTouching = true;
    params = new BehaviorSubject<any>(null);
    private cleanupTime = new Subject<void>();
    topics: any[];
    isLast: any;

    constructor(private streamService: StreamService, private route: ActivatedRoute) {}
    
    ngOnInit(): void {
        this.route.parent.params.pipe(takeUntil(this.cleanupTime))
        .subscribe(() => {
            this.topics = [];
            this.isLast = false;
            this.params.next({
                    page: 0,
                    rows: 50,
                    sort: this.route.snapshot.queryParams.sort || 'title',
                    sortDirection: this.route.snapshot.queryParams.sortDirection || 'asc',
                    catalogId: this.route.parent.snapshot.params.catalogId
            });
        });
        this.route.queryParams.pipe(takeUntil(this.cleanupTime))
        .subscribe(() => {
            this.topics = [];
            this.isLast = false;
            this.params.next({
                    page: 0,
                    rows: 50,
                    sort: this.route.snapshot.queryParams.sort || 'title',
                    sortDirection: this.route.snapshot.queryParams.sortDirection || 'asc',
                    catalogId: this.route.parent.snapshot.params.catalogId 
            });
        });
        this.params.pipe(
            filter(params => !!params),
            distinctUntilChanged((a, b) => {
                return a.page === b.page && 
                       a.rows === b.rows &&
                       a.sort === b.sort && 
                       a.sortDirection === b.sortDirection &&
                       a.catalogId === b.catalogId;
            }),
            tap(() => this.noTouching = true),
            flatMap(params => this.streamService.getCatalogStreams(params.catalogId, params)),
            tap(() => this.noTouching = false)
        ).subscribe(topicResults => {
            this.isLast = topicResults.last;
            this.topics = this.topics.concat(topicResults.content);
        });

        this.params.next({
            page: 0,
            rows: 50,
            sort: this.route.snapshot.queryParams.sort || 'title',
            sortDirection: this.route.snapshot.queryParams.sortDirection || 'asc',
            catalogId: this.route.parent.snapshot.params.catalogId 
        });
    }

    nextPage(): void {
        if (!this.isLast) {
            this.params.next(Object.assign({}, this.params.value, { page: this.params.value.page + 1 }));
        }
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
